export const LoadingMsg = () => {
  return <tr className='loading'><td><p>데이터가 없습니다.</p></td></tr>
}